<template>
  <b-modal :id="`filtrosAvancados`"
           :ref="`filtrosAvancados`"
           no-close-on-backdrop
           no-close-on-esc
           class="FiltrosAvancados"
           header-class="FiltrosAvancados_header"
           body-class="FiltrosAvancados_body"
           content-class="FiltrosAvancados_content"
           size="xl"
           visible
           @ok="getFilters()"
           @hide="hideFilters()">
    <template slot="modal-header">
      <div>
        <b class="ml-2">Filtros avançados</b>
      </div>
    </template>
    <div class="row">
      <div class="col-12 p-0 px-2">
        <label for="detalhamento">Detalhamento</label>
        <input id="detalhamento"
               v-model="localData.detalhamento"
               type="text"
               class="form-control form-control-sm">
      </div>
    </div>
    <div v-if="propTipo.includes('DESPESA')"
         class="row px-2 mt-2">
      <div class="col-6 pl-0">
        <label for="categoria">Categoria</label>
        <v-select v-model="localData.categoria_id"
                  :options="categoriasDespesa"
                  label="nome"
                  :reduce="categoria => categoria.categoria_id"
                  :class="{ 'is-invalid': errors.has('pais') }"
                  class="form-control form-control-sm"
                  name="categoria" />
      </div>
      <div class="col-6 pr-0">
        <label for="beneficiario">Beneficiário</label>
        <v-select v-model="localData.fornecedor_id"
                  :options="propFornecedores"
                  label="nome"
                  :reduce="fornecedor => fornecedor.fornecedor_id"
                  :class="{ 'is-invalid': errors.has('pais') }"
                  class="form-control form-control-sm"
                  name="fornecedor" />
      </div>
    </div>
    <div v-else
         class="row px-2 mt-2">
      <div class="col-6 pl-0">
        <label for="ato">Tipo de ato</label>
        <v-select v-model="localData.categoria_id"
                  :options="categoriasReceita"
                  label="nome"
                  :reduce="categoria => categoria.categoria_id"
                  :class="{ 'is-invalid': errors.has('pais') }"
                  class="form-control form-control-sm"
                  name="categoria" />
      </div>
    </div>
    <template slot="modal-footer"
              slot-scope="{ ok, cancel }">
      <button class="btn btn-sm btn-light px-3"
              @click="cancel">
        Voltar
      </button>
      <button class="btn btn-sm btn-secondary px-3"
              @click="ok">
        Continuar
      </button>
    </template>
  </b-modal>
</template>

<script>
  export default {
    name: 'FiltrosAvancados',
    props: {
      propTipo: { type: String, default: 'RECEITA'},
      propCategorias: { type: Array, default: () => ([])},
      propFornecedores: { type: Array, default: () => ([])},
      propFiltros: { type: Object, default: null }
    },
    data () {
      return {
        localData: {
          detalhamento: null,
          categoria_id: null,
          beneficiario_id: null
        }
      }
    },
    computed: {
      categoriasReceita () {
        const categorias = []

        this.propCategorias.forEach((categoria) => {
          const unique = categorias.find(cat => cat.nome === categoria.nome)

          if (!unique) categorias.push(categoria)
        })

        return categorias.filter((categoria) => categoria.tipo === 'RECEITA')
      },
      categoriasDespesa () {
        const categorias = []

        this.propCategorias.forEach((categoria) => {
          const unique = categorias.find(cat => cat.nome === categoria.nome)

          if (!unique) categorias.push(categoria)
        })

        return categorias.filter((categoria) => categoria.tipo === 'DESPESA')
      }
    },
    mounted () {
      if (this.propFiltros) {
        this.localData = this.propFiltros
      }
    },
    methods: {
      getFilters () {
        this.$emit('getFilters', this.localData)
      },
      hideFilters () {
        this.$emit('hide')
      }
    }
  }
</script>

<style lang="scss">
  .FiltrosAvancados {
    &_header {
      background: #074f7f;
      color: #fff;
      padding: 10px;
      font-size: 20px;
      font-weight: bold;
      border-radius: 0px;
    }

    &_content {
      border-radius: 0px;
    }

    &_body {
      padding: 10px 40px;
    }

    &_body label {
      font-size: 16px;
      font-weight: 500;
      color: #373a3c;
    }

    &_subtitle {
      border-bottom: 1px solid black ;
      margin: 10px 0px;
    }

    &_subtitle h1 {
      font-size: 18px;
      font-weight: 500;
      color: #262626;
    }
  }
</style>
